import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ContactService } from './../../services/contact.service';

@Component({
  selector: 'app-add-customer',
  templateUrl: './add-customer.component.html',
  styleUrls: ['./add-customer.component.css']
})
export class AddCustomerComponent implements OnInit {

  user_id: any = '';
  company_id: any = '';
  APIKEY: any = '';
  model: any = {
  };
  assign_fact: string;
  div1: boolean = true;
  div2: boolean = false;
  div3: boolean = true;
  arrayOne(n: number): any[] {
    return Array(n);
  }
  n: number = 1;
  biiling_mode: boolean = false;
  biiling_read_only: boolean = false;
  btnDisable: boolean = false;


  constructor(private _contact: ContactService,
    private _router: Router,
    private toastr: ToastrService,) { }

  ngOnInit() {
    this.user_id = localStorage.getItem('id'),
      this.company_id = localStorage.getItem('company_id');
    this.APIKEY = localStorage.getItem('APIKEY');
    this.model = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id
    };
    this.model["terms"] = '';
    this.model["status"] = 'active';
    this.model["creditlimit"] = '0.00';
    this.model["assign_fact"] = '1';
    this.model['markup'] = 'off';
    this.model['noa'] = 'on';
    // get auto conatct number 
    //this code commented by deepak on 23march2022
    /*this._contact.getContactNumber(this.model)
    .subscribe(
      res => { 
       // console.log(res);
       this.model["customer_no"] =res.data;
       this.model["assign_fact"] = 1;
     },
    );*/
    //end

  }

  //   onChange(divvalue,e)
  //  {

  // if(divvalue=='div1') {
  //   if(e.target.checked)
  // {
  // this.div2=true; this.div3=false; 
  // }
  // else  {
  //   this.div3=true;this.div2=false;
  // } 
  // }

  // if(divvalue=='div3'){
  //   if(e.target.checked){
  //     this.div3=true; this.div2=false;
  //   }else{
  //     this.div1=true;this.div2=false;
  //   }
  // }

  // }

  isNumberKey(evt) {
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;

    return true;
  }



  onSubmit(form) {
    this.btnDisable = true;
    //  console.log(this.model);//  return false;
    this._contact.saveContact(this.model)
      .subscribe(
        res => {
          // console.log(res);
          if (res.status == true) {
            this.toastr.success(res.message, 'Success');
          }
          else {
            this.toastr.error(res.message, 'Error');
          }
          this._router.navigate(['/customer/customer-list/active']);
        },
      );
  }


  public setBillingMode(value: boolean) {
    if (value == true) {
      this.model["same_as_check"] = 'yes';
      this.model["bill_address1"] = this.model["main_address1"];
      this.model["bill_address2"] = this.model["main_address2"];
      this.model["bill_country"] = this.model["main_country"];
      this.model["bill_city"] = this.model["main_city"];
      this.model["bill_state"] = this.model["main_state"];
      this.model["bill_zip"] = this.model["main_zip"];
      this.biiling_read_only = true;
    }
    else {
      this.model["same_as_check"] = 'no';
      this.model["bill_address1"] = '';
      this.model["bill_address2"] = '';
      this.model["bill_country"] = '';
      this.model["bill_city"] = '';
      this.model["bill_state"] = '';
      this.model["bill_zip"] = '';
      this.biiling_read_only = false;
    }
  }


  //   public assign_fact_NoStamp(value) {

  //     this.model["assign_fact"] = value;
  //     // console.log(this.model);
  // }

  onlyAlpha_numberic(evt) {

    // Only ASCII charactar in that range allowed 
    var ASCIICode = (evt.which) ? evt.which : evt.keyCode
    //alert(ASCIICode);
    if ((ASCIICode >= 48 && ASCIICode <= 57) || (ASCIICode >= 65 && ASCIICode <= 90) || (ASCIICode >= 97 && ASCIICode <= 122) || ASCIICode == 38 || ASCIICode == 32 || ASCIICode == 39 || ASCIICode == 40 || ASCIICode == 41 || ASCIICode == 45 || ASCIICode == 44 || ASCIICode == 46)
      return true;
    return false;
  }

  onlyAlpha_numberic_address(evt) {

    // Only ASCII charactar in that range allowed 
    var ASCIICode = (evt.which) ? evt.which : evt.keyCode
    //alert(ASCIICode);
    if ((ASCIICode >= 48 && ASCIICode <= 57) || (ASCIICode >= 65 && ASCIICode <= 90) || (ASCIICode >= 97 && ASCIICode <= 122) || ASCIICode == 38 || ASCIICode == 32 || ASCIICode == 39 || ASCIICode == 40 || ASCIICode == 41 || ASCIICode == 45 || ASCIICode == 44 || ASCIICode == 46 || ASCIICode == 35)
      return true;
    return false;
  }



}
